module.exports = __webpack_public_path__ + "img/studio_blank_dashboard.73e49ec1.png";